import { connect } from 'react-redux';
import { IApplicationState } from '../../types/redux';
import { changeTabs } from '../../actions/location';
import { PikStandardComponent } from './pik-standard';

export const PikStandard = connect(
  (state: IApplicationState) => ({
    tabs: state.tabs,
  }),
  {
    changeTabs,
  },
)(PikStandardComponent);
